import './PSoftWare.scss'
import PageFooter from "../PageFooter"
import React from "react"
import Layout from "../../Layout"
import Text from "../../mobile/component/Text"

function PSoftWare() {

	const handleClick = () => {
		window.location.href = 'http://caryunos.com/public/account/#/login'
	}


	return (
		<>
			<Layout>
				<div className={'soft-container'}>
					<div className={'soft-container-content'}>
						<div className={'title'}>
							<div className={'logo'}></div>
							{/*<ul className={'title-list'}>*/}
							{/*	<li>系统特点</li>*/}
							{/*	<li>基础应用</li>*/}
							{/*	<li>增值应用</li>*/}
							{/*	<li>平台应用</li>*/}
							{/*	<li>新手入门</li>*/}
							{/*	<li>联系我们</li>*/}
							{/*</ul>*/}
						</div>

						<Text top={54} fontFamily="bold" fontSize={40} color="#FFFFFF" style={{textAlign: "center"}}>
							车云AI操作系统
						</Text>
						<Text fontWeight={100}
							  top={10}
							  fontFamily="normal"
							  fontSize={22}
							  color="#FFFFFF"
							  style={{textAlign: "center", letterSpacing: "4px"}}>
							让门店经营插上AI的翅膀
						</Text>


						<div className="osBox flex fAlignCenter fJustifyBetween">
							<div className="iphone box flex">
								<div className="iphoneBg"></div>
								<div>
									<Text top={110} bottom={30} fontFamily="bold" fontSize={30} className="text">
										手机端
									</Text>

									<div className="btn iphoneBtn">下载<span className="upload"></span></div>
									<div className="btn iphoneBtnHover">扫码下载</div>
								</div>
							</div>

							<div className="pc box flex">
								<div className="pcBg"></div>
								<div>
									<Text top={110} bottom={30} fontFamily="bold" fontSize={30} className="text">
										电脑端
									</Text>
									<div className="btn pcBtn pointer" onClick={handleClick}>进入<span
										className="right"></span></div>
									<div className="btn pcBtnHover pointer" onClick={handleClick}>进入<span
										className="rightHover"></span></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<PageFooter/>
			</Layout>

		</>
	)
}


export default PSoftWare
